import { AssistantRemoteDataSource } from "../../datasources/assistant/assistant-remote.datasource";
import type { IAssistantRemoteDataSource } from "../../datasources/assistant/assistant-remote.datasource.interface";
import type { IChatbotRepository } from "./chatbot.repository.interface";

export class ChatbotRepository implements IChatbotRepository {
  constructor(private readonly _remoteDataSource: IAssistantRemoteDataSource = new AssistantRemoteDataSource()) {}

  public async storePrompt(prompt: string): Promise<void> {
    await this._remoteDataSource.storePrompt(prompt);
  }
}
